import * as React from "react";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Textfield from "../../Components/Textfield";
import Textarea from "../../Components/Textarea";
import Button from "../../Components/Button";
import Select from "../../Components/Select";
import TopBarNotConnected from "../../Components/TopBarNotConnected";
import Motive from "./Motive";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";
import Logo from "./../../Images/logo_white.png";

import "./AddContactNotConnected.scss";

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  address: "",
  zipcode: "",
  city: "",
  phone_number: "",
  type: "",
  date: "",
  time: "",
  message: "",
  governorate: "",
};

const AddContactNotConnected = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [cities, setCities] = React.useState([]);

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/cities`).then((response) => {
      setCities(response.data?.data || []);
    });
  }, []);

  // const handleChangeField = (e, key) => {
  //   setFormErrorMessages((prev) => ({
  //     ...prev,
  //     [key]: "",
  //   }));

  //   setValRegister((prev) => ({
  //     ...prev,
  //     [key]: e.target.value,
  //   }));
  // };
  const handleChangeField = (value, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "zipcode") {
      const selectedCity = cities.find(
        (city) => city.zip_code === parseInt(value, 10)
      );
      if (selectedCity) {
        setValRegister((prev) => ({
          ...prev,
          governorate: selectedCity.governorate,
          city: selectedCity.governorate + " (" + selectedCity.title + ") ",
        }));
      } else {
        setValRegister((prev) => ({
          ...prev,
          governorate: "",
          city: "",
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/leasing-contact-advisor`, {
        first_name: valRegister.first_name,
        last_name: valRegister.last_name,
        email: valRegister.email,
        address: valRegister.address,
        zipcode: valRegister.zipcode,
        city: valRegister.city,
        phone_number: valRegister.phone_number,
        type: valRegister.type,
        date: valRegister.date,
        time: valRegister.time,
        message: valRegister.message,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Prenez votre rendez-vous
        </div>
      </div>
      <div className="wrap-app">
        <TopBarNotConnected
          backTo
          url="/"
          title="Prise de RDV"
          description="Veuillez compléter votre demande de prise de Rendez-vous"
        />
        <div className="container-app container-app-not-connected">
          <form className="register-form" onSubmit={handleSubmit} noValidate>
            <Textfield
              autoComplete="off"
              label="Nom"
              name="last_name"
              type="text"
              size="large"
              value={valRegister.last_name}
              onChange={(e) => handleChangeField(e.target.value, "last_name")}
              hasError={formErrorMessages.last_name}
              errorMessage={
                formErrorMessages.last_name && (
                  <div className="text-danger">
                    {formErrorMessages.last_name}
                  </div>
                )
              }
            />
            <Textfield
              autoComplete="off"
              label="Prénom"
              name="first_name"
              type="text"
              size="large"
              value={valRegister.first_name}
              onChange={(e) => handleChangeField(e.target.value, "first_name")}
              hasError={formErrorMessages.first_name}
              errorMessage={
                formErrorMessages.first_name && (
                  <div className="text-danger">
                    {formErrorMessages.first_name}
                  </div>
                )
              }
            />
            <Textfield
              autoComplete="off"
              label="Email"
              name="email"
              type="text"
              size="large"
              value={valRegister.email}
              onChange={(e) => handleChangeField(e.target.value, "email")}
              hasError={formErrorMessages.email}
              errorMessage={
                formErrorMessages.email && (
                  <div className="text-danger">{formErrorMessages.email}</div>
                )
              }
            />
            <Textfield
              autoComplete="off"
              label="Adresse"
              name="address"
              type="text"
              size="large"
              value={valRegister.address}
              onChange={(e) => handleChangeField(e.target.value, "address")}
              hasError={formErrorMessages.address}
              errorMessage={
                formErrorMessages.address && (
                  <div className="text-danger">{formErrorMessages.address}</div>
                )
              }
            />
            <Select
              label="Code Postal"
              id="zipcode"
              value={valRegister.zipcode || ""}
              onChange={(e) => handleChangeField(e.target.value, "zipcode")}
              hasError={formErrorMessages.zipcode}
              errorMessage={
                <div className="text-danger">
                  {formErrorMessages.zipcode}
                </div>
              }
            >
              <option value=""></option>
              {cities.map((city, index) => (
                <option key={index} value={city.zip_code}>
                  {city.zip_code}
                </option>
              ))}
            </Select>

            {/* <Select
                label="Ville"
                id="city"
                value={valRegister.city || ""}
                onChange={(e) => handleChangeField(e.target.value, "city")}
                hasError={formErrorMessages.city}
                errorMessage={
                  <div className="text-danger">{formErrorMessages.city}</div>
                }
              >
                <option value=""></option>
                {cities.map((city) => (
                  <option key={city.governorate} value={city.governorate}>
                    {city.governorate}
                  </option>
                ))}
              </Select> */}

            <Textfield
              autoComplete="off"
              label="Ville"
              name="city"
              type="text"
              size="large"
              disabled
              value={valRegister.city}
              onChange={(e) => handleChangeField(e.target.value, "city")}
              hasError={formErrorMessages.city}
              errorMessage={
                formErrorMessages.city && (
                  <div className="text-danger">{formErrorMessages.city}</div>
                )
              }
            />
            <Textfield
              autoComplete="off"
              label="Téléphone"
              name="phone_number"
              type="number"
              size="large"
              value={valRegister.phone_number}
              onChange={(e) =>
                handleChangeField(e.target.value, "phone_number")
              }
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "+" ||
                  e.key === "-" ||
                  e.key === "."
                ) {
                  e.preventDefault();
                }
              }}
              hasError={formErrorMessages.phone_number}
              errorMessage={
                formErrorMessages.phone_number && (
                  <div className="text-danger">
                    {formErrorMessages.phone_number}
                  </div>
                )
              }
            />

            {/* <Textfield
                autoComplete="off"
                label="Code Postal"
                name="zipcode"
                type="text"
                size="large"
                value={valRegister.zipcode}
                onChange={(e) => handleChangeField(e, "zipcode")}
                hasError={formErrorMessages.zipcode}
                errorMessage={
                  formErrorMessages.zipcode && (
                    <div className="text-danger">
                      {formErrorMessages.zipcode}
                    </div>
                  )
                }
              /> */}

            <Motive
              label="Motif de prise de RDV"
              name="type"
              id="type"
              value={valRegister.type || ""}
              onChange={(e) => handleChangeField(e.target.value, "type")}
              required
              hasError={formErrorMessages.type}
              errorMessage={
                <div className="text-danger">{formErrorMessages.type}</div>
              }
            ></Motive>
            <div className="wrap-immatriculation">
              <Textfield
                autoComplete="off"
                label="Date"
                name="date"
                type="date"
                size="large"
                min={new Date().toISOString().split("T")[0]}
                value={valRegister.date}
                onChange={(e) => handleChangeField(e.target.value, "date")}
                hasError={formErrorMessages.date}
                errorMessage={
                  formErrorMessages.date && (
                    <div className="text-danger">{formErrorMessages.date}</div>
                  )
                }
              />
              <Textfield
                autoComplete="off"
                label="Heure"
                name="time"
                type="time"
                size="large"
                value={valRegister.time}
                onChange={(e) => handleChangeField(e.target.value, "time")}
                hasError={formErrorMessages.time}
                errorMessage={
                  formErrorMessages.time && (
                    <div className="text-danger">{formErrorMessages.time}</div>
                  )
                }
              />
            </div>
            <Textarea
              autoComplete="off"
              label="Message"
              name="message"
              type="text"
              placeholder="Message"
              size="large"
              value={valRegister.message}
              onChange={(e) => handleChangeField(e.target.value, "message")}
              hasError={formErrorMessages.message}
              errorMessage={
                formErrorMessages.message && (
                  <div className="text-danger">{formErrorMessages.message}</div>
                )
              }
            />
            <div className="wrap_actions_form">
              <Button type="submit" size="lg">
                Envoyer
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddContactNotConnected;
